export default __webpack_public_path__ + "static/earth_night_map-3ef3220dafe9761b0bf8b54065d45228.jpg";